import { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { BillableItemTypes } from '@racemap/sdk/schema/user';
import { FrontendBillableItemTypes } from 'src/store/events/FrontendBillableItemTypes';

type BillingItemType = BillableItemTypes | StripeProducts | FrontendBillableItemTypes;

// One table per enum: they share values ('key', 'sms', ...), which one object literal rejects.
const BILLABLE_ITEM_LABELS: Record<BillableItemTypes, string> = {
  [BillableItemTypes.BASE_PRICE]: 'Base price',
  [BillableItemTypes.SAFEMAP_BASE_PRICE]: 'Safemaps',
  [BillableItemTypes.EVENT_CYCLE]: 'Maps',
  [BillableItemTypes.KEY]: 'Used Keys',
  [BillableItemTypes.SPONSOR]: 'Add-On: Sponsor',
  [BillableItemTypes.TIMING]: 'Add-On: Leaderboard',
  [BillableItemTypes.MONITOR]: 'Add-On: Monitor', // TODO: remove later, kept for backward compatibility
  [BillableItemTypes.DATA_FEED]: 'Add-On: Data API',
  [BillableItemTypes.HIGH_RESOLUTION]: 'Add-On: High Resolution',
  [BillableItemTypes.DATA_USAGE_ZONE_1]: 'Data usage zone 1',
  [BillableItemTypes.DATA_USAGE_ZONE_1_V6_SIM]: 'Data usage zone 1',
  [BillableItemTypes.DATA_USAGE_ZONE_2]: 'Data usage zone 2',
  [BillableItemTypes.DATA_USAGE_ZONE_2_V6_SIM]: 'Data usage zone 2',
  [BillableItemTypes.DATA_USAGE_ZONE_3]: 'Data usage zone 3',
  [BillableItemTypes.DATA_USAGE_ZONE_3_V6_SIM]: 'Data usage zone 3',
  [BillableItemTypes.DATA_USAGE_ZONE_4_V5_SIM]: 'Data usage zone 4',
  [BillableItemTypes.DATA_USAGE_ZONE_4]: 'Data usage zone 4',
  [BillableItemTypes.SIM_CARD]: 'Subscription: SIM card',
  [BillableItemTypes.APP]: 'App',
  [BillableItemTypes.TRACKER_MANAGEMENT]: 'Tracker Management',
  [BillableItemTypes.GPS_DEVICE]: 'GPS Device',
  [BillableItemTypes.TRANSPONDER]: 'Transponder',
  [BillableItemTypes.STARTER]: 'Devices (Legacy)',
  [BillableItemTypes.PAGE_VIEW]: 'Loads (Legacy)',
  [BillableItemTypes.EXTEND_EVENT]: 'Extend Event (Legacy)',
  [BillableItemTypes.SMS]: 'SMS',
  [BillableItemTypes.ACTIVATE_EVENT]: 'Activate Event',
  [BillableItemTypes.EVENT_DAY]: 'Event Day',
};

const STRIPE_PRODUCT_LABELS: Record<StripeProducts, string> = {
  [StripeProducts.BASE_PRICE]: 'Base price',
  [StripeProducts.SAFEMAP_BASE_PRICE]: 'Safemaps',
  [StripeProducts.MAP]: 'Maps',
  [StripeProducts.SAFEMAP]: 'Safemaps',
  [StripeProducts.KEY]: 'Used Keys',
  [StripeProducts.SPONSOR_ADDON]: 'Add-On: Sponsor',
  [StripeProducts.TIMING_ADDON]: 'Add-On: Leaderboard',
  [StripeProducts.MONITOR_ADDON]: 'Add-On: Monitor',
  [StripeProducts.API_ADDON]: 'Add-On: Data API',
  [StripeProducts.HIGH_RESOLUTION_ADDON]: 'Add-On: High Resolution',
  [StripeProducts.DATA_USAGE_ZONE_1]: 'Data usage zone 1',
  [StripeProducts.DATA_USAGE_ZONE_2]: 'Data usage zone 2',
  [StripeProducts.DATA_USAGE_ZONE_3]: 'Data usage zone 3',
  [StripeProducts.DATA_USAGE]: 'Data usage',
  [StripeProducts.SIM_CARD_ACTIVATION]: 'Subscription: SIM card',
  [StripeProducts.CUSTOM_APP]: 'App',
  [StripeProducts.TRACKER_MANAGEMENT]: 'Tracker Management',
  [StripeProducts.TRACKER_RENTAL]: 'Tracker Rental',
  [StripeProducts.GPS_DEVICE]: 'GPS Device',
  [StripeProducts.TRANSPONDER]: 'Transponder',
  [StripeProducts.MAP_OR_MONITOR_LOAD]: 'Map and Monitor Loads',
  [StripeProducts.API_OR_LEADERBOARD_LOAD]: 'API and Leaderboard Loads',
  [StripeProducts.STARTER]: 'Devices (Legacy)',
  [StripeProducts.PAGE_VIEW]: 'Loads (Legacy)',
  [StripeProducts.SMS]: 'SMS',
};

const FRONTEND_ITEM_LABELS: Record<FrontendBillableItemTypes, string> = {
  [FrontendBillableItemTypes.EVENT_CREATED]: 'Event created',
};

const LABELS: Record<BillingItemType, string> = {
  ...BILLABLE_ITEM_LABELS,
  ...STRIPE_PRODUCT_LABELS,
  ...FRONTEND_ITEM_LABELS,
};

export function getLabelForBillingItemType(billingItemType: BillingItemType): string {
  if (!Object.hasOwn(LABELS, billingItemType)) {
    throw new Error(`Unknown billing item type: ${billingItemType}`);
  }
  return LABELS[billingItemType];
}
